<mat-drawer-container class="landing-container h-100" @blockTransition>
	<mat-drawer-content>
		<div class="p-2">
			<div class="mt-2 pt-3">
				<div fxLayout="row" fxLayoutAlign="center center" class="h-100 error-container block">
					<div fxFlex="80" fxFlex.gt-sm="30" fxFlex.sm="60" class="mat-elevation-z6">
						<app-content-header [activeMenu]="activeMenu" [class]="'pt-4 pb-3'"></app-content-header>
						<div class="p-4 text-center" @fadeIn>
							<p class="pt-2">Existing account: <b>{{email}}</b></p>
							<button mat-raised-button color="primary" class="mat-elevation-z6 mt-3" type="button" (click)="logOutLogIn()">Login using {{recommendedLogin}}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</mat-drawer-content>
</mat-drawer-container>